import { render } from "./ResourceView.vue?vue&type=template&id=4f58086a&ts=true"
import script from "./ResourceView.vue?vue&type=script&lang=ts"
export * from "./ResourceView.vue?vue&type=script&lang=ts"

import "./ResourceView.vue?vue&type=style&index=0&id=4f58086a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__